import { Container, Typography } from "@mui/material";
import { Marksome, References } from "react-marksome";

const ContactUs = () => {
  const { bodyText1, bodyText2 } = text;
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Typography variant="h5" align="left" sx={styles.title}>
        VÕTA ÜHENDUST
      </Typography>
      <Typography paragraph variant="body1" align="left">
        <Marksome text={bodyText1} references={references} />
      </Typography>
      <Typography paragraph variant="body1" align="left">
        <Marksome text={bodyText2} references={references} />
      </Typography>
    </Container>
  );
};

export default ContactUs;

const styles = {
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    height: "100%",
  },
  title: {
    fontWeight: 600,
    py: "4%",
  },
};
const text = {
  bodyText1:
    "DÜKA test on loodud [Oksana Palikova][1] magistritöös (2022) välja töötatud lahenduse alusel" +
    " (lähemalt vt [https://dspace.ut.ee/handle/10062/83429][2]).",
  bodyText2:
    "DÜKA testi veebirakendus on loodud 2022. a Tartu Ülikooli IT eriala üliõpilaste poolt LTAT.05.005 " +
    "Tarkvaraprojekt aine raames. Veebilahenduse loojateks on " +
    "[Regita Luukas][3], [Karl Erik Mander][4], Peter Kallaste ja [Karl-Hendrik Veidenberg][5].",
};

const references: References = {
  1: "https://www.etis.ee/CV/Oksana_Palikova/est/#",
  2: "https://dspace.ut.ee/handle/10062/83429",
  3: "https://www.linkedin.com/in/regita-luukas-863539219/",
  4: "https://www.linkedin.com/in/karl-erik-mander",
  5: "https://www.linkedin.com/in/karl-hendrikveidenberg/",
};
